import { render, staticRenderFns } from "./LotProductionRegisterVG.vue?vue&type=template&id=2bcf39f0"
import script from "./LotProductionRegisterVG.vue?vue&type=script&lang=js"
export * from "./LotProductionRegisterVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports